import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { IssueServiceService } from 'src/app/admin/services/issues/issue-service.service';
import { UserdataService } from 'src/app/admin/services/shared/userdata/userdata.service';

@Component({
    selector: 'app-reply-astrologer-support',
    templateUrl: './reply-astrologer-support.component.html',
    styleUrls: ['./reply-astrologer-support.component.scss'],
    standalone: false
})
export class ReplyAstrologerSupportComponent implements OnInit {

  constructor(
    private userdata: UserdataService,
    private spinner: NgxSpinnerService,
    private issueService: IssueServiceService,
    private router: ActivatedRoute,
    private toast: ToastrService,
    private route: Router
  ) { }

  data:any = '';
  id: any = '';
  supportId: any = ''
  title: any = ''
  description: any = ''
  issueSolved:boolean = false

  ngOnInit(): void {
    this.id = this.router.snapshot.paramMap.get('id')
    this.getDataById()
    this.formGroup.patchValue({ userId: this.userdata.getId() })
    this.formGroup.patchValue({ addedBy: this.userdata.getName() })
    this.formGroup.patchValue({ _id: this.id })
  }

  formGroup: UntypedFormGroup = new UntypedFormGroup({
    userId: new UntypedFormControl('', Validators.required),
    _id: new UntypedFormControl('', Validators.required),
    reply_by_system: new UntypedFormControl('', Validators.required),
    addedBy: new UntypedFormControl('', Validators.required),
    is_issue_solved: new UntypedFormControl(false)
  });


  getDataById() {
    this.spinner.show()
    this.issueService.getSingleSupport({ _id: this.id }).subscribe(
      (res: any) => {
        this.spinner.hide()
        //console.log(res)
        this.data = res.data
        this.supportId = res.data.supportId
        this.title = res.data.support_title
        this.description = res.data.support_description
      },
      err => {
        this.route.navigateByUrl('/admin/support/astrologer')
      }
    )
  }

  get f() {
    return this.formGroup.controls
  }

  /* ***********
  Reply Issue
 *********** */

  public replyIssue() {
    this.spinner.show();
    this.issueService.replySupport(this.formGroup.value).subscribe(
      (res: any) => {
        this.spinner.hide()
        //console.log(res)
        this.toast.success('Issue Resolved!', 'Success');
        this.route.navigateByUrl('/admin/support/astrologer')
      },
      err => {
        this.spinner.hide()
        //console.log(err)
        this.toast.error('Something went wrong!', 'Error');
      })

  }

  isIssueSolved(event:any){
    if(event.target.checked){
      //console.log('checked')
      this.formGroup.patchValue({is_issue_solved:true})
    }else{
      //console.log('unchecked')
      this.formGroup.patchValue({is_issue_solved:false})
    }
  }

}
